import { render, staticRenderFns } from "./PriceRangeItems.vue?vue&type=template&id=f9047fd0&"
import script from "./PriceRangeItems.vue?vue&type=script&lang=ts&"
export * from "./PriceRangeItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports